import {
    Component,
    EventEmitter,
    Input,
    Output,
    ChangeDetectionStrategy
} from "@angular/core";
import { SelectedListItem } from "./listSelectedItems.models";
import { ButtonComponent } from "../button/button.component";
import { NgbPopover } from "@ng-bootstrap/ng-bootstrap";
import { BlockComponent } from "../container-block/block.component";
import { ListComponent } from "../list/list.component";
import { ListColumnDirective } from "../list/list-column.directive";
import { CheckboxComponent } from "../checkbox/checkbox.component";
import { FormsModule } from "@angular/forms";
import { IconButtonComponent } from "../icon-button/icon-button.component";

@Component({
    selector: "rask-list-selected-items",
    templateUrl: "./list-selected-items.component.html",
    styleUrls: ["./list-selected-items.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        ButtonComponent,
        NgbPopover,
        BlockComponent,
        ListComponent,
        ListColumnDirective,
        CheckboxComponent,
        FormsModule,
        IconButtonComponent
    ]
})
export class ListSelectedItemsComponent {
    @Input() data: SelectedListItem[];
    @Output() removeFromSelection = new EventEmitter<SelectedListItem>();

    getButtonText(): string {
        return `Markerade (${this.data.length})`;
    }

    removeFromList(item: SelectedListItem) {
        item.checked = false;
        this.removeFromSelection.emit(item);
    }
}
